export const Feedbacks = [
    {
        name: "Lora Ipsen",
        profession: "Eco activist",
        photo: "user_photo.svg",
        stars: 5,
        message: "“Dolor sit amet, consectetur adipiscing elit , sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.”"
    },
    {
        name: "Lora Ipsen",
        profession: "Eco activist",
        photo: "user_photo.svg",
        stars: 4,
        message: "“Dolor sit amet, consectetur adipiscing elit , sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.”"
    },
    {
        name: "Lora Ipsen",
        profession: "Eco activist",
        photo: "user_photo.svg",
        stars: 3,
        message: "“Dolor sit amet, consectetur adipiscing elit , sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.”"
    },
    {
        name: "Lora Ipsen",
        profession: "Eco activist",
        photo: "user_photo.svg",
        stars: 2,
        message: "“Dolor sit amet, consectetur adipiscing elit , sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.”"
    },
    {
        name: "Lora Ipsen",
        profession: "Eco activist",
        photo: "user_photo.svg",
        stars: 1,
        message: "“Dolor sit amet, consectetur adipiscing elit , sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.”"
    },
    {
        name: "Lora Ipsen",
        profession: "Eco activist",
        photo: "user_photo.svg",
        stars: 5,
        message: "“Dolor sit amet, consectetur adipiscing elit , sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.”"
    },
    {
        name: "Lora Ipsen",
        profession: "Eco activist",
        photo: "user_photo.svg",
        stars: 5,
        message: "“Dolor sit amet, consectetur adipiscing elit , sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.”"
    }
]